// extracted by mini-css-extract-plugin
export default {"expertDescription":"LsRfZ"};